import DashboardApi from "./api";
import * as actionTypes from "./actionTypes";
import { sendHttpRequest } from "../../actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadClientOfferChartData(force) {
  return async (dispatch, getState) => {
    let { clientOfferChartData } = getState().dashboard;
    if (!force && clientOfferChartData) {
      return;
    }

    try {
      const data = await dispatch(sendHttpRequest(DashboardApi.getClientOfferData()));
      dispatch({ type: actionTypes.LOAD_CLIENT_OFFER_CHART_DATA_SUCCESS, payload: data });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadClientOfferStatusChartData(force) {
  return async (dispatch, getState) => {
    let { clientOfferStatusChartData } = getState().dashboard;
    if (!force && clientOfferStatusChartData) {
      return;
    }

    try {
      const data = await dispatch(sendHttpRequest(DashboardApi.getClientOfferStatusChartData()));
      dispatch({ type: actionTypes.LOAD_CLIENT_OFFER_STATUS_CHART_DATA_SUCCESS, payload: data });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadTopClientsChartData(force) {
  return async (dispatch, getState) => {
    let { topClientsChartData } = getState().dashboard;
    if (!force && topClientsChartData) {
      return;
    }

    try {
      const data = await dispatch(sendHttpRequest(DashboardApi.getTopClientsData()));
      dispatch({ type: actionTypes.LOAD_TOP_CLIENTS_CHART_DATA_SUCCESS, payload: data });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadLatestClientsChartData(force) {
  return async (dispatch, getState) => {
    let { latestClientsChartData } = getState().dashboard;
    if (!force && latestClientsChartData) {
      return;
    }

    try {
      const data = await dispatch(sendHttpRequest(DashboardApi.getLatestClientsData()));
      dispatch({ type: actionTypes.LOAD_LATEST_CLIENTS_CHART_DATA_SUCCESS, payload: data });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
